import React from 'react';
import './Active.scss';
import Slide from 'component/Slide';

function Active(): JSX.Element {
  return (
    <section className="page active-page">
      <Slide />
    </section>
  );
}

export default Active;
